import { AppDispatch } from "../store/store";
import { ErrorResponse } from "./Requests";
import { requestError } from "../store/reducers/requestStateSlice";
import { UserManagementErrorCode } from "./userManagementErrorCode";
import { ErrorCode } from "./errorCode";

type UserManagementErrorResult = {
    duplicateUserName: boolean;
};

export function handleUserManagementError(
    dispatch: AppDispatch,
    errorResponse: ErrorResponse | null | undefined
): UserManagementErrorResult {
    const innerErrors = errorResponse?.data?.errors;
    const duplicateUserName = !!innerErrors?.some(
        (e: { code: string }) => e.code === UserManagementErrorCode.DuplicateUserName
    );

    if (!duplicateUserName) {
        const defaultResponse: ErrorResponse = {
            message: "Unknown Error",
            errorCode: ErrorCode.GeneralError,
            statusCode: 0,
        };
        dispatch(requestError(errorResponse ?? defaultResponse));
    }

    return { duplicateUserName };
}